<div class="container mt-2 mt-md-4">

  <div class="row">
    <div class="col-12 text-center">

      <p class="fw-bold">Exporta tu información para importarla en A3</p>

    </div>
  </div>

  <div class="row mt-2">
    <div class="col-6">

      <mat-form-field class="d-block">
        <input matInput [matDatepicker]="from" placeholder="Fecha de inicio" name="request.from" weekStart=1
          [(ngModel)]="request.from">
        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
        <mat-datepicker #from></mat-datepicker>
      </mat-form-field>

    </div>

    <div class="col-6">

      <mat-form-field class="d-block">
        <input matInput [matDatepicker]="to" placeholder="Fecha de fin" name="request.to" weekStart=1
          [(ngModel)]="request.to">
        <mat-datepicker-toggle matSuffix [for]="to"></mat-datepicker-toggle>
        <mat-datepicker #to></mat-datepicker>
      </mat-form-field>

    </div>
  </div>

  <div class="row">
    <div class="col-6">
      <app-select [(ngModel)]="typeInformation"
        [config]="{ label: 'Tipo de información', loadOptions: () => typeInformationOptions }">
      </app-select>
    </div>

    <div class="col-6">
      <app-input inputType="text" placeholder="Identificador A3" [(ngModel)]="request.companyCode"></app-input>
    </div>
  </div>

  <div class="row">
    <div class="col-12">

      <button mat-stroked-button (click)="download()" [disabled]="loadingRequest">
        <mat-icon>file_download</mat-icon>
        Exportar
        <mat-icon *ngIf="loadingRequest" class="cf-spin-icon">autorenew</mat-icon>
      </button>

    </div>
  </div>

</div>
